import type { CogentLive, CogentQuestion } from "./chat-view";

import s from "../cogent.module.css";

export function ChatChoices({
  question,
  send,
}: {
  question: CogentQuestion;
  send: CogentLive["send"];
}) {
  return (
    <div className={s.choice} data-testid="cogent-question">
      <p className={s.soft}>{question.question}</p>
      <div className={s.row}>
        {question.options.map((option) => (
          <button
            key={option.label}
            type="button"
            className={s.secondary}
            title={option.description ?? undefined}
            onClick={() =>
              void send({
                text: option.label,
                answer: {
                  questionId: question.id,
                  choice: option.label,
                  other: null,
                },
              })
            }
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}
